import { TimeUtils } from 'src/common/timeUtils';
import { ultimaFichada, ticketsPendientes, recursosHumanosReady } from './../../store/recursos-humanos/recursos-humanos.selectors';
import { TicketsPendientes } from 'src/common/ticketsPendientes';
import { Component, OnInit } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Observable, combineLatest } from 'rxjs';
import { NotificacionBundle } from 'src/common/notificacionBundle';
import { Fichada } from 'src/common/fichada';
import { UltimaFichadaRequested, TicketsPendientesRequested } from '../../store/recursos-humanos/recursos-humanos.actions';
import { filter, map } from 'rxjs/operators';
import { AccesoPerfil } from 'src/common/acceso';
import { aplicacionPerfiles } from '../../store/aplicacion/aplicacion.selectors';

@Component({
	selector: 'self-service',
	templateUrl: './self-service.component.html',
	styleUrls: ['./self-service.component.scss']
})
export class SelfServiceComponent implements OnInit {

	readonly STORED_LINK: ManagedLinkKey = ManagedLinkKey.STORED_LINK;
	readonly MI_GESTION: string = 'mi-gestion';

	selfServiceKey: ManagedLinkKey = ManagedLinkKey.SELF_SERVICE;
	recursosHumanosFAQ: ManagedLinkKey = ManagedLinkKey.RECURSOS_HUMANOS_FAQ;
	ultimaFichada$: Observable<NotificacionBundle<Fichada>>;
	ticketsPendientes$: Observable<NotificacionBundle<TicketsPendientes>>;
	recursosHumanosReady$: Observable<boolean>;
	showUltimaFichada$: Observable<boolean>;
	showTicketsPendientes$: Observable<boolean>;
	showTooltip$: Observable<boolean>;
	miGestionAplicacionPerfil$: Observable<AccesoPerfil>;	

	constructor( private store: Store<AppState>, private timeUtils: TimeUtils ) {
	}

	ngOnInit() {
		this.ultimaFichada$ = this.store.select( ultimaFichada );
		this.ticketsPendientes$ = this.store.select( ticketsPendientes );
		this.recursosHumanosReady$ = this.store.select( recursosHumanosReady );
		this.showUltimaFichada$ = this.ultimaFichada$.pipe(
			map( ultimaFichada => !this.isEmptyBundle( ultimaFichada ) )
		);
		this.showTicketsPendientes$ = this.ticketsPendientes$.pipe(
			map( ticketsPendientes => !this.isEmptyBundle( ticketsPendientes ) )
		);
		this.showTooltip$ = combineLatest( [ this.showUltimaFichada$, this.showTicketsPendientes$ ] ).pipe(
			map( ([showUltimaFichada, showTicketsPendientes]) => showUltimaFichada || showTicketsPendientes ),
		);
		this.miGestionAplicacionPerfil$ = this.store.select( aplicacionPerfiles( this.MI_GESTION ) ).pipe(
			filter( perfiles => perfiles && perfiles.length > 0 ),
			map( perfiles => perfiles[0] )	// Para simplificar supongo que mi-gestion tiene un único perfil
		);
	}

	public isEmptyBundle( notificacion: NotificacionBundle<Object> ): boolean {
		return notificacion == null || notificacion.bundle == null || notificacion.bundle.length == 0;
	}

	public getTimeAsString( fichada: Fichada ): string {
		let timeAsString: string = '--:--';

		if( fichada != null && fichada.fechaString != null && fichada.fechaString.length > 0 ) {
			// fechaString: '18/03/2019 08:21:08'
			// Intento parsear la hora desde el sring fichada.fechaString
			let part: string[] = fichada.fechaString.trim().split( ' ' );
			if( part.length == 2 ) {
				let time: string = part[1];
				part = time.split( ':' );
				if( part.length == 3 )
					timeAsString = part[0] + ':' + part[1];
			}
		}

		return timeAsString;
	}

	public getDateAsString( fichada: Fichada ): string {
		let dateAsString: string = 'No disponible';

		if( fichada != null && fichada.fechaString != null && fichada.fechaString.length > 0 ) {
			// fechaString: '18/03/2019 08:21:08'
			// Intento parsear la fecha desde el sring fichada.fechaString
			let part: string[] = fichada.fechaString.trim().split( ' ' );
			if( part.length == 2 ) {
				let date: string = part[0];
				part = date.split( '/' );
				if( part.length == 3 ) {
					let monthAsNumber: number = parseInt( part[1] );
					if( !Number.isNaN( monthAsNumber ) ) {
						let monthAsString: string = this.timeUtils.getMonthAsString( monthAsNumber - 1, true );
						if( monthAsString != null && monthAsString != '' )
							dateAsString = part[0] + ' ' + monthAsString + ' ' + part[2];
					}
				}
			}

			// Agrego si corresponde diaDesc
			if( fichada.diaDesc )
				dateAsString = fichada.diaDesc + ', ' + dateAsString;
		}

		return dateAsString;
	}

	public onRefreshRecursosHumanos(): void {
		this.store.dispatch( new UltimaFichadaRequested() );
		this.store.dispatch( new TicketsPendientesRequested() );
	}

/*
 * private methods
 */




	// 08:21 hs
	// 18 Mar 2019

}
